import { normalizePath, normalizeQuery } from '@helsenorge/core-utils/url';
import { getCookieValue, getSuffix } from '../cookie';
import { getPath } from '../hn-page';
import { setSharedCookie } from '../shared-cookies';
import { getBrukerflate } from '.';
export const PREVIOUS_PAGE_PATH_COOKIE_NAME = 'hn-previous-page-path';
const getHostname = () => {
    if (typeof window === 'undefined') {
        return '';
    }
    return window.location.hostname;
};
/**
 * Returnerer navnet på cookien som lagrer forrige pagePath.
 *
 * @returns Navn på cookie
 */
export const getPreviousPagePathCookieName = () => getSuffix(PREVIOUS_PAGE_PATH_COOKIE_NAME);
/**
 * Hent forrige pagePath fra cookie. Dette brukes for å kunne sende "previousPagePath" i Amplitude-eventer, selv ved hard refresh eller direkte navigasjon til en side.
 */
const getPreviousPagePathFromCookie = () => {
    return getCookieValue(PREVIOUS_PAGE_PATH_COOKIE_NAME) || '';
};
/**
 * Lagre pagePath i cookie, slik at det kan hentes ut som "previousPagePath" ved neste sidevisning.
 */
const setPreviousPagePathCookie = (path) => {
    setSharedCookie(getPreviousPagePathCookieName(), path, 0);
};
/**
 * Plugin for å legge til globale variabler i Amplitude-eventer, som "pagePath" og "brukerflate".
 *
 * Plugin eksponeres på window for at den skal kunne brukes i andre deler av applikasjonen, f.eks.
 * for å oppdatere "pagePath" ved navigasjon i vertikalene.
 */
class GlobalVariablesPlugin {
    name = 'hn-global-variables';
    type = 'enrichment';
    pagePath = '';
    previousPagePath;
    query = '';
    // Henter pagePath. Kan brukes for å lese nåværende verdi før oppdatering.
    getPagePath() {
        return this.pagePath;
    }
    // Setter pagePath, som brukes i Amplitude-eventer. Bør kalles ved navigasjon i vertikalene.
    setPagePath(path) {
        // Ta vare på forrige path i pluginen. Ved første kall (hard refresh / SSR) hentes verdien fra cookie.
        this.previousPagePath = this.pagePath || getPreviousPagePathFromCookie();
        this.pagePath = path ? normalizePath(path) : '';
        // Lagre nåværende path i cookie slik at den overlever hard refresh / SSR-navigasjon
        if (this.pagePath) {
            setPreviousPagePathCookie(this.pagePath);
        }
    }
    // Henter previousPagePath. Kan brukes for å lese nåværende verdi før oppdatering.
    getPreviousPagePath() {
        if (this.previousPagePath !== undefined) {
            return this.previousPagePath;
        }
        return getPreviousPagePathFromCookie();
    }
    // Henter query. Kan brukes for å lese nåværende verdi før oppdatering.
    getQuery() {
        return this.query;
    }
    // Setter query, som brukes i Amplitude-eventer. Bør kalles ved navigasjon i vertikalene.
    setQuery(query) {
        this.query = query ? normalizeQuery(query) : '';
    }
    async execute(event) {
        const host = getHostname();
        const globalVariables = {
            brukerflate: getBrukerflate(),
            pageLocation: host + this.pagePath + this.query,
            pagePath: this.pagePath,
            pageUrl: host + this.pagePath,
            previousPagePath: this.getPreviousPagePath(),
            tjeneste: getPath(),
        };
        event.event_properties = {
            ...event.event_properties,
            ...globalVariables,
        };
        return event;
    }
}
const globalVariablesPlugin = window.__HN_PATH_PLUGIN__ || new GlobalVariablesPlugin();
window.__HN_PATH_PLUGIN__ = globalVariablesPlugin;
export default globalVariablesPlugin;
